export default {
  label_cancel: 'Cancelar',
  label_clear: 'Limpiar',
  label_today: 'Hoy',
  label_now: 'Ahora',
  label_validate: 'Confirmar',
  label_from: '',
  label_to: ''
}
